import { ready } from './helpers.js';
import { onScroll } from './helpers.js';
const musicIcons = [
  '/wp-content/themes/wass/assets/icons/music-icon-1.svg',
  '/wp-content/themes/wass/assets/icons/music-icon-2.svg',
  '/wp-content/themes/wass/assets/icons/music-icon-3.svg',
  '/wp-content/themes/wass/assets/icons/music-icon-4.svg',
  '/wp-content/themes/wass/assets/icons/music-icon-5.svg',
]
const wineIcons = [
  '/wp-content/themes/wass/assets/icons/wine-icon-1.svg',
  '/wp-content/themes/wass/assets/icons/wine-icon-2.svg',
  '/wp-content/themes/wass/assets/icons/wine-icon-3.svg',
]
const weedIcons = [
  '/wp-content/themes/wass/assets/icons/weed-icon-1.svg',
  '/wp-content/themes/wass/assets/icons/weed-icon-2.svg',
  '/wp-content/themes/wass/assets/icons/weed-icon-3.svg',
]

function initParticleSystemForContainer(container, svgImages, particleCount = 50) {
  // Create and style the canvas overlay
  const canvas = document.createElement('canvas');
  canvas.style.position = 'absolute';
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.pointerEvents = 'none'; // Overlay doesn't capture mouse events
  container.style.position = 'relative';
  container.appendChild(canvas);

  const ctx = canvas.getContext('2d');

  // Set canvas dimensions to match container
  function setCanvasSize() {
    canvas.width = container.offsetWidth;
    canvas.height = container.offsetHeight;
  }
  setCanvasSize();
  window.addEventListener('resize', setCanvasSize);

  // Preload SVG images
  const loadedImages = [];
  let imagesLoaded = 0;
  svgImages.forEach(src => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      imagesLoaded++;
      if (imagesLoaded === svgImages.length) {
        createParticles();
        animate();
      }
    };
    loadedImages.push(img);
  });

  const particles = [];

  // Helper to generate a random number between min and max
  function randomRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  // Create a new particle with randomized properties
  function createParticle() {
    return {
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.2,
      vy: (Math.random() - 0.5) * 0.3,
      ampX: randomRange(0.2, 1),
      ampY: randomRange(0.2, 1),
      freqX: randomRange(0.005, 0.015),
      freqY: randomRange(0.005, 0.015),
      image: loadedImages[Math.floor(Math.random() * loadedImages.length)],
      size: randomRange(30, 50),
      life: 0,
      lifespan: randomRange(500, 1000)
    };
  }

  // Create all particles
  function createParticles() {
    for (let i = 0; i < particleCount; i++) {
      particles.push(createParticle());
    }
  }

  // Update each particle's position and lifecycle
  function updateParticles() {
    particles.forEach(p => {
      p.life++;
      // Currently, no dynamic oscillation is applied
      const offsetX = 0;
      const offsetY = 0;

      p.x += p.vx + offsetX;
      p.y += p.vy + offsetY;
      
      if (p.x > canvas.width) p.x = 0;
      if (p.x < 0) p.x = canvas.width;
      if (p.y > canvas.height) p.y = 0;
      if (p.y < 0) p.y = canvas.height;

      // Reset particle once its lifespan is exceeded
      if (p.life > p.lifespan) {
        const newParticle = createParticle();
        p.x = newParticle.x;
        p.y = newParticle.y;
        p.vx = newParticle.vx;
        p.vy = newParticle.vy;
        p.ampX = newParticle.ampX;
        p.ampY = newParticle.ampY;
        p.freqX = newParticle.freqX;
        p.freqY = newParticle.freqY;
        p.image = newParticle.image;
        p.size = newParticle.size;
        p.life = 0;
        p.lifespan = newParticle.lifespan;
      }
    });
  }

  // Draw the particles on the canvas with a dynamic blur and fade effect
  function drawParticles() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      const alpha = Math.sin((p.life / p.lifespan) * Math.PI);
      const maxBlur = 5;
      const blurAmount = (1 - alpha) * maxBlur;

      ctx.filter = `blur(${blurAmount}px)`;
      ctx.globalAlpha = alpha;
      ctx.drawImage(p.image, p.x, p.y, p.size, p.size);
      ctx.filter = 'none';
      ctx.globalAlpha = 1;
    });
  }

  // Main animation loop
  function animate() {
    updateParticles();
    drawParticles();
    requestAnimationFrame(animate);
  }
}
function initParticleSystemOnAll(containerClass, svgImages, particleCount = 50) {
  const containers = document.querySelectorAll(`.${containerClass}`);
  if (containers.length === 0) {
    console.error(`No containers found with class "${containerClass}"`);
    return;
  }
  containers.forEach(container => {
    initParticleSystemForContainer(container, svgImages, particleCount);
  });
}
ready(function () {
  const allIcons = [...weedIcons, ...musicIcons, ...wineIcons];
  initParticleSystemOnAll('particle-notes-wrapper', allIcons, 30);

  onScroll((scrollY) => {
    document.querySelectorAll('.particle-notes-wrapper').forEach(notesWrapper => {
      const notesCanvas = notesWrapper.querySelector('canvas');
      if (notesCanvas) {
        notesCanvas.style.transform = `translateY(${scrollY}px)`;
      }
    });
  });
});

